import ProphiaLogo from "@/assets/prophia/prophia_abstract_full_logo_inverted.png";
import SecondaryButton from "../../buttons/secondary-button/SecondaryButton";
import { LOGIN_ROUTE } from "@/routing/app-routes";
import { useTranslation } from "react-i18next";
import styles from "./sharing-banner.module.scss";

export const SharingBanner = () => {
  const { t } = useTranslation();

  const navigateTo = (route) => {
    window.open(route, "_blank");
  };

  return (
    <div className="no-print">
      <div
        className={`${styles.sharingBanner} flex between align-center ml-4 mr-4 p-4`}
      >
        <img src={ProphiaLogo} alt="Prophia Logo" />
        <div className="flex">
          <SecondaryButton
            text={t("login")}
            onClick={() => navigateTo(LOGIN_ROUTE)}
          />
        </div>
      </div>
    </div>
  );
};

export default SharingBanner;
